import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    children: PropTypes.node,
};

const defaultProps = {
    children: null,
};

/*
 * Component
 */
function CustomInfoBox({ children }) {
    return (
        <div className="custom-info-box">
            <div className="custom-info-box-content">
                {children}
            </div>
            <span className="arrow" />
        </div>
    );
}

CustomInfoBox.propTypes = propTypes;
CustomInfoBox.defaultProps = defaultProps;

export default CustomInfoBox;
